import SectionCard from './SectionCard';

/**
 * FilingProgress — per-form on-time percentage bars from the deadline engine.
 * Falls back to zeroed AOC-4 / MGT-7 / DIR-3 KYC rows when no data.
 */
export default function FilingProgress({ filingProgress }) {
  const items = filingProgress.length
    ? filingProgress.map((f) => ({ label: f.label, value: f.value }))
    : [{ label: 'AOC-4', value: 0 }, { label: 'MGT-7', value: 0 }, { label: 'DIR-3 KYC', value: 0 }];

  return (
    <SectionCard
      icon="reporting"
      iconTone="#4a6b3f"
      title="Filing Progress"
      subtitle="% of applicable companies with filing on time"
    >
      <div className="p-4">
        {items.map((item) => (
          <div key={item.label} className="mb-2.5 last:mb-0">
            <div className="flex justify-between text-[11px] mb-0.5">
              <span className="text-[#7a7060] font-medium">{item.label}</span>
              <span className="font-bold text-[#08111f]">{item.value}%</span>
            </div>
            <div className="h-[4px] rounded-full overflow-hidden" style={{ background: '#faf7f2' }}>
              <div className="h-full rounded-full transition-all duration-500" style={{ width: `${item.value}%`, background: '#4a6b3f' }} />
            </div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
